module.exports = __webpack_public_path__ + "img/k5-21.8c064c1d.png";